import { FC } from 'react';

import { DateTimeUtils } from '@servicetitan/datetime-utils';
import { BodyText, Button, Icon, Stack } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import { ConnectedAppSecretResponse } from '../../api/app.api';

const Secret: FC<{
    secret: ConnectedAppSecretResponse | null;
    onGenerateClick: () => void;
    onDeactivateClick: (secret: ConnectedAppSecretResponse) => void;
}> = ({ secret, onGenerateClick, onDeactivateClick }) => {
    const [{ formatDateFull, formatShortTime }] = useDependencies(DateTimeUtils);

    return (
        <Stack direction="row" spacing={3}>
            <Stack.Item>
                <Icon name="vpn_key" size={30} />
            </Stack.Item>
            <Stack.Item fill>
                {secret ? (
                    <Stack direction="column">
                        <BodyText large>{secret.valuePrefix}...</BodyText>
                        <BodyText subdued>
                            generated on {formatDateFull(secret.createdOn)} at{' '}
                            {formatShortTime(secret.createdOn)}
                        </BodyText>
                    </Stack>
                ) : (
                    'Not generated yet'
                )}
            </Stack.Item>
            <Stack.Item>
                {secret ? (
                    <Button negative outline onClick={() => onDeactivateClick(secret)}>
                        Deactivate
                    </Button>
                ) : (
                    <Button primary outline onClick={onGenerateClick}>
                        Generate
                    </Button>
                )}
            </Stack.Item>
        </Stack>
    );
};
Secret.displayName = 'Secret';

export const SecretList: FC<{
    secrets: ConnectedAppSecretResponse[];
    onGenerateClick: () => void;
    onDeactivateClick: (secret: ConnectedAppSecretResponse) => void;
}> = ({ secrets, onGenerateClick, onDeactivateClick }) => {
    return (
        <Stack direction="column" spacing={2}>
            <Secret
                secret={secrets.length > 1 ? secrets[0] : null}
                onGenerateClick={onGenerateClick}
                onDeactivateClick={onDeactivateClick}
            />
            <Secret
                secret={secrets.length > 0 ? secrets[secrets.length - 1] : null}
                onGenerateClick={onGenerateClick}
                onDeactivateClick={onDeactivateClick}
            />
        </Stack>
    );
};
SecretList.displayName = 'SecretList';
